import React from 'react';
import { createRoot } from 'react-dom/client';
import { ChakraProvider, Box, ColorModeScript } from '@chakra-ui/react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { theme } from './theme/theme.config';
import { MainView } from './components/views/external-views/main-view/main-view';
import { ScrollToTop } from './components/utils/scroll-to-top';
import { MsalProvider } from './auth/MsalProvider';
import UnsubscribePage from './components/views/unsubscribe/unsubscribe';
import './index.scss';
import './styles/tailwind.css'; // Import Tailwind styles

const Vynterface: React.FC = () => {
  return (
    <BrowserRouter>
      <Box minH="100vh" bg="inherit">
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<MainView />} />
          <Route path="/unsubscribe" element={<UnsubscribePage />} />
        </Routes>
      </Box>
    </BrowserRouter>
  );
};

const container = document.querySelector('#root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ColorModeScript initialColorMode={theme.config.initialColorMode} />
    <MsalProvider>
      <ChakraProvider theme={theme}>
        <Vynterface />
      </ChakraProvider>
    </MsalProvider>
  </React.StrictMode>
);
